import { Autocomplete, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dashboard_Accurate from "../../../assets/images/dashboard_Accurate.svg";
import dashboard_BenchmarkingAttract from "../../../assets/images/dashboard_BenchmarkingAttract.svg";
import dashboard_Global_compensation from "../../../assets/images/dashboard_Global_compensation.svg";
import dashboard_User_User_Group from "../../../assets/images/dashboard_User_User_Group.svg";
import dashboard_working from "../../../assets/images/dashboard_working.svg";
import Loader from "../../../components/loader";
import CustomButtonComponent from "../../../components/PayAnalytics/CommonComponents/CustomButtonComponent";
import { RootState } from "../../../store/reducers";
import {
  CountryDetailsThunk,
  CountryListThunk,
  getCountryOptionKey,
  Icountry,
  setSelectedCountry
} from "../../../store/slices/countryDetailsSlice";
import { dateFormatter } from "../../../utilities/dateFormatter";
import { numberFormatter } from "../../../utilities/numberFormatter";
import styles from "./Landing.module.scss";
import "./Landing.scss";

declare let pendo: any;

const filterCountryOptions = (
  options: Icountry[],
  { inputValue }: { inputValue: string }
) => {
  const search = inputValue.trim().toLowerCase();
  if (!search) {
    return options;
  }
  return options.filter((option) =>
    option.label.toLowerCase().includes(search)
  );
};

const Landing = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [countryDetails, setCountryDetails] = useState<any>();
  const [selectedcountry, setSelectedcountryState] = useState<Icountry | null>(
    null
  );
  const { country } = useSelector((state: any) => {
    return state;
  });
  const { selectedClient } = useSelector((state: RootState) => {
    return state.clients;
  });
  const countryList = useSelector((state: any) => {
    return state.country.countryList;
  });
  const countryListAPIData = useSelector((state: any) => {
    return state.country.countryListAPIData;
  });
  useEffect(() => {
    let countryCode = sessionStorage.getItem("countryCode");
    if (countryCode && countryListAPIData?.countryList?.length > 0) {
      let index = countryListAPIData?.countryList.findIndex(
        (ele: any) => ele.countryId === countryCode
      );
      if (index > -1) {
        const selected = countryListAPIData.countryList[index];
        let dropdownFormat: Icountry = {
          key: selected.countryCode,
          label: selected.countryName,
          countryId: selected.countryId,
          productBrandId: selected.productBrandId,
          uniqueId: `${selected.countryCode}-${selected.countryId}-${selected.productBrandId}`
        };
        handleCountryInputChange(dropdownFormat);
      }
      sessionStorage.removeItem("countryCode");
    }
    if (
      countryListAPIData &&
      countryListAPIData?.userId &&
      countryListAPIData?.clientId
    ) {
      pendo?.initialize({
        visitor: {
          id: countryListAPIData.userId, // Required if user is logged in
          userLanguage: "en"
        },
        account: {
          id: countryListAPIData.clientId // Highly recommended
        }
      });
    }
  }, [countryListAPIData]);

  useEffect(() => {
    if (countryList?.length < 1) {
      //  when the country api gives data with clientid , we should not call this when the selected client is there
      Object.keys(selectedClient).length === 0 &&
        dispatch(CountryListThunk(""));
    }
  }, []);

  const handleCountryInputChange = (newValue: Icountry | null) => {
    setSelectedcountryState(newValue);
    setCountryDetails([]);
    (newValue != null || undefined) &&
      dispatch(CountryDetailsThunk(newValue?.key));
    dispatch(setSelectedCountry(newValue));
  };

  useEffect(() => {
    setCountryDetails(country?.countryDetails[0]);
    // Only set the selected country if it hasn't been selected by user interaction
    if (!selectedcountry && country?.countryDetails?.length > 0) {
      const prevCountry = country?.countryDetails[0];
      if (prevCountry) {
        setSelectedcountryState({
          label: prevCountry.countryName ?? country?.selectedCountry?.label,
          key: prevCountry.countryCode ?? country?.selectedCountry?.key,
          countryId: country?.selectedCountry?.countryId,
          productBrandId: country?.selectedCountry?.productBrandId,
          uniqueId: country?.selectedCountry?.uniqueId
        });
      }
    }
  }, [country?.countryDetails]);

  useEffect(() => {
    if (
      country?.selectedCountry?.key &&
      country.selectedCountry.key !== selectedcountry?.key
    ) {
      setSelectedcountryState(country.selectedCountry);
      dispatch(CountryDetailsThunk(country.selectedCountry.key));
    }
  }, [country?.selectedCountry]);

  return (
    <div className={`${styles.homeContainer} container`}>
      <Grid container spacing={2} className={styles.dashboardParent}>
        <Grid item xs={12}>
          <Stack
            direction="row"
            spacing={10}
            className={styles.dashboardBenchmarkStack}
          >
            <Paper
              elevation={0}
              className={styles.dashboardBenchmarkStack_left}
              sx={{ paddingLeft: "3rem" }}
            >
              <div className={styles.dashboardBenchmarkStack_left_heading}>
                {t("pa.rewardIntelligently")}
              </div>
              <br />
              <div className={styles.dashboardBenchmarkStack_left_description}>
                {t("pa.rewardBenchmarkingReport")} <br />
                <br />
                {t("pa.createCustomReport")}
              </div>
            </Paper>
            <Paper className={styles.dashboardBenchmarkStack_Right}>
              {country?.countryError ? (
                <div className="no-access">{t("pa.userDontHaveAccess")}</div>
              ) : (
                <div>
                  <div className={styles.dashboardBenchmarkStack_Right_heading}>
                    {t("pa.benchMarkMarket")}
                  </div>
                  <Autocomplete
                    className="dashboardBenchmarkStack_Right-Autocomplete"
                    loading={country?.isCountryListLoading}
                    options={countryList}
                    filterOptions={filterCountryOptions}
                    getOptionKey={getCountryOptionKey}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.label ?? ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      getCountryOptionKey(option) === getCountryOptionKey(value)
                    }
                    value={selectedcountry}
                    onChange={(event: any, newValue: Icountry | null) => {
                      handleCountryInputChange(newValue);
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={getCountryOptionKey(option)}>
                        {option.label}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={t("pa.selectCountry")}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {country?.isCountryListLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          )
                        }}
                      />
                    )}
                  />
                  <div
                    className={styles.dashboardBenchmarkStack_Right_menu_div}
                  >
                    {country?.isCountryDetailsLoading && <Loader />}
                    <div className="same-line">
                      <img
                        src={dashboard_User_User_Group}
                        style={{ marginRight: "10px" }}
                        alt="KornFerry"
                      />
                      <Typography
                        className={
                          styles.dashboardBenchmarkStack_Right_textItems
                        }
                      >
                        {selectedcountry && (
                          <strong>
                            {numberFormatter(
                              countryDetails?.numberOfIncumbents
                            )}
                          </strong>
                        )}{" "}
                        {t("pa.incumbents")}
                        {selectedcountry &&
                          country?.selectedCountry?.label &&
                          "in " + country?.selectedCountry?.label}
                      </Typography>
                    </div>
                    <br />
                    <div className="same-line last">
                      <img
                        src={dashboard_working}
                        style={{ marginRight: "10px" }}
                        alt="KornFerry"
                      />
                      <Typography
                        className={
                          styles.dashboardBenchmarkStack_Right_textItems
                        }
                      >
                        {selectedcountry &&
                          countryDetails?.numberOfOrganizations && (
                            <strong>
                              {countryDetails?.numberOfOrganizations}
                            </strong>
                          )}{" "}
                        {t("pa.organizations")}{" "}
                        {selectedcountry &&
                          country?.selectedCountry?.label &&
                          "in " + country?.selectedCountry?.label}
                      </Typography>
                    </div>
                    <hr className={styles.line} />
                    <Typography
                      className={styles.dashboardBenchmarkStack_Right_textItems}
                    >
                      {t("pa.currency")}:{" "}
                      {selectedcountry && countryDetails?.currencyName}
                    </Typography>
                    <br />
                    <Typography
                      className={styles.dashboardBenchmarkStack_Right_textItems}
                    >
                      {t("pa.databaseUpdated")}:{" "}
                      {selectedcountry &&
                        countryDetails?.effectiveDate &&
                        dateFormatter(countryDetails?.effectiveDate)}
                    </Typography>
                  </div>
                  <br />
                  <CustomButtonComponent
                    text={t("pa.createCustomReportButton")}
                    variant={"contained"}
                    onClick={() => {
                      const selectedCountryCode =
                        countryDetails?.countrycode ??
                        countryDetails?.countryCode ??
                        country?.selectedCountry?.key;
                      navigate(
                        `/pay-analytics/reward-benchmark?countryCode=${selectedCountryCode}`
                      );
                    }}
                    disabled={
                      country?.countryDetails?.length < 1 ||
                      countryDetails?.length < 1
                    }
                  />
                </div>
              )}
            </Paper>
          </Stack>
        </Grid>
        <Grid container>
          <Paper className={styles.dashboardReportStack}>
            <Typography className={styles.dashboardReportStack_Heading}>
              {t("pa.whatToExpect")}
            </Typography>
            <Stack direction="row" spacing={1}>
              <Paper elevation={0} className={styles.dashboardReportStack_item}>
                <img
                  src={dashboard_Accurate}
                  style={{ margin: "auto" }}
                  alt="KornFerry"
                />
                <Typography
                  className={styles.dashboardReportStack_item_heading}
                >
                  {t("pa.accurate")}
                  <br /> {t("pa.uptoDate")}
                </Typography>
                <Typography
                  className={styles.dashboardReportStack_item_description}
                ></Typography>
              </Paper>
              <Paper elevation={0} className={styles.dashboardReportStack_item}>
                <img src={dashboard_Global_compensation} alt="KornFerry" />
                <Typography
                  className={styles.dashboardReportStack_item_heading}
                >
                  {t("pa.globalCompensation")}
                  <br /> {t("pa.insights")}
                </Typography>
                <Typography
                  className={styles.dashboardReportStack_item_description}
                ></Typography>
              </Paper>
              <Paper elevation={0} className={styles.dashboardReportStack_item}>
                <img src={dashboard_BenchmarkingAttract} alt="KornFerry" />
                <Typography
                  className={styles.dashboardReportStack_item_heading}
                >
                  {t("pa.benchMarkingtoAttract")}
                  <br />
                  {t("pa.retainTopTalent")}
                </Typography>
                <Typography
                  className={styles.dashboardReportStack_item_description}
                ></Typography>
              </Paper>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default Landing;
